import { Component, OnInit } from '@angular/core';
import {ApplicationStateService} from '../../../../services/application-state.service';

@Component({
  selector: 'app-aztec-process-info',
  templateUrl: './aztec-process-info.component.html',
  styleUrls: []
})
export class AztecProcessInfoComponent implements OnInit {

  phoneImageSrc = './assets/images/aztec-phone.png';
  steps: string[] = [
      'AZTEC_PROCESS_INFO.steps.step1',
      'AZTEC_PROCESS_INFO.steps.step2',
      'AZTEC_PROCESS_INFO.steps.step3',
      'AZTEC_PROCESS_INFO.steps.step4',
      'AZTEC_PROCESS_INFO.steps.step5',
  ];
  qrCodeUrl: string;

  constructor(private stateService: ApplicationStateService) {
  }

  ngOnInit() {
      this.qrCodeUrl = this.stateService.entryUrl;
  }

}
